import styled from "styled-components";

export const TableContainer = styled.div<{ isLoading: boolean }>`
	${props => (props.isLoading ? `opacity:0.2` : ``)};
`;
